exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  font-size: 14pt;\n}\nform {\n  margin-bottom: 10px;\n}\nform md-input-container.textareaContainer {\n  width: 100%;\n}\nform md-input-container.mat-input-container {\n  min-width: 280px;\n}\nform div.btnContainer {\n  overflow: auto;\n}\nform div.btnContainer button {\n  float: right;\n}\nform #email {\n  display: none;\n}\nform textarea {\n  min-height: 7rem;\n}\n.spinner {\n  position: fixed;\n  z-index: 99999999999999999;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  background-color: rgba(220, 220, 255, 0.5);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/contact/contact.component.less
// module id = ../../../../../src/app/content/contact/contact.component.less
// module chunks = 1